import React, {useState} from 'react';
import {Button} from '@mui/material';
import AddTaskIcon from '@mui/icons-material/AddTask';
import {useNavigate} from 'react-router-dom';
import {TaskDTO} from "../../api";
import TaskDialog from './TaskDialog';


interface NewTaskButtonProps {
  refreshTasks?: () => Promise<void>;
  preAssignedLeadId?: number;
}

const NewTaskButton: React.FC<NewTaskButtonProps> = ({ refreshTasks, preAssignedLeadId }) => {
  const [open, setOpen] = useState(false);
    useNavigate();

    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
    setOpen(false);
  };

  const handleSave = async (task: TaskDTO) => {
    // This won't be called for new tasks as TaskDialog handles creation internally
    // But we keep it for consistency with the interface
  };

  return (
    <>
      <Button
          data-testid="new-task-button"
          onClick={handleOpen}
          startIcon={<AddTaskIcon />}
          sx={{
            background: 'linear-gradient(to right, #06b6d4, #2563eb)',
            color: 'white',
            px: 2,
            py: 0.5,
            borderRadius: '9999px', // pełna pastylka
            fontWeight: 400,
            textTransform: 'none',
            boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.2)',
            '&:hover': {
              background: 'linear-gradient(to right, #059dc5, #1e4ed8)',
            },
          }}
      >
        Nowe zadanie
      </Button>

      <TaskDialog
        open={open}
        onClose={handleClose}
        task={null}
        onSave={handleSave}
        refreshTasks={refreshTasks}
        preAssignedLeadId={preAssignedLeadId}
      />
    </>
  );
};

export default NewTaskButton;
